import { render, staticRenderFns } from "./GoodMall.vue?vue&type=template&id=1e26a54d&scoped=true"
import script from "./GoodMall.vue?vue&type=script&lang=js"
export * from "./GoodMall.vue?vue&type=script&lang=js"
import style0 from "./GoodMall.vue?vue&type=style&index=0&id=1e26a54d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e26a54d",
  null
  
)

export default component.exports